import { render } from "./InsightsTranscriptView.vue?vue&type=template&id=bdd56b36&ts=true"
import script from "./InsightsTranscriptView.vue?vue&type=script&lang=ts"
export * from "./InsightsTranscriptView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__